// If you don't have a theme.js, create one and wrap your app with ThemeProvider in App.js

import { createTheme } from '@mui/material/styles';

const theme = (primaryThemeColor, primaryThemeFontColor, primaryFontFamily, secondaryFontFamily, backgroundThemeColor) => createTheme({
  typography: {},
  overrides: {},
  palette: {
    primary: {
      main: primaryThemeColor,
    },
    secondary: {
      main: "#000",
    },
    background: {
      default: backgroundThemeColor,
    },
    success : {
      main : primaryThemeColor,
    },
    error : {
      main : "#d32f2f",
    },
    white: {
      main: '#fff',
    },
  },
});

export default theme;
